import moment from 'moment';
import GalleryService from '../services/gallery.service';

const getFileType = (file) => {
  if (file) {
    const index = file.lastIndexOf('.');
    return file.slice(index + 1);
  }
  return file;
};

const groupImages = (t, gallery) => {
  const groupedImages = {
    [GalleryService.TODAY]: [],
  };
  gallery.forEach((img) => {
      groupedImages[GalleryService.TODAY].push({ ...img,
        created_at: moment(img.created_at).format('HH:mm'),
        type: getFileType(img.original) });
  });

  Object.keys(groupedImages).forEach((item) => {
    if (!groupedImages[item].length) { delete groupedImages[item]; }
  });
  return groupedImages;
};


export default {
  groupImages,
  getFileType,
};



// WEBPACK FOOTER //
// ./src/helpers/gallery.helper.js